module.exports = __webpack_public_path__ + "static/media/confirm-action.d4ee1c2d.svg";